<template>
  <div>
    <v-toolbar flat height="90">
      <v-btn
        color="secondary"
        class="text-capitalize ml-2"
        depressed
        v-text="translations.createNewAttribute[lang]"
        @click="openAttributesDialog({})"
      ></v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <b-data-table
      :headers="headersAttributes"
      :items="attributes"
      :page.sync="page"
      @page-sync="(p) => (page = p)"
      :loading="loading"
    >
      <template v-slot:item.user_account_attribute_definition_values="{ item }">
        <div
          v-if="
            item.user_account_attribute_definition_values &&
            item.user_account_attribute_definition_values.length > 0
          "
        >
          <div v-if="item.attribute_type == 'radio'">
            <v-container class="px-0" fluid>
              <v-radio-group row readonly>
                <v-radio
                  readonly
                  v-for="n in item.user_account_attribute_definition_values"
                  color="secondary"
                  :key="n.user_account_attribute_definition_value_id"
                  :label="`${n.value}`"
                  :value="n.value"
                ></v-radio>
              </v-radio-group>
            </v-container>
          </div>
          <div v-else>
            <v-chip-group column class="table-chips" style="width: 100%">
              <v-chip
                v-for="(s, i) in item.user_account_attribute_definition_values"
                :key="i"
                class="font-weight-bold px-1 pr-2 pl-2"
                style="overflow: visible"
              >
                {{ s.value }}
              </v-chip>
            </v-chip-group>
          </div>
        </div>
        <div v-else>-</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn color="secondary" icon v-on="on" @click="openAttributesDialog(item)">
              <v-icon v-text="icons.mdiPencilOutline"></v-icon>
            </v-btn>
          </template>
          <span class="font-weight-bold" v-text="translations.update[lang]"></span>
        </v-tooltip>
        <v-tooltip color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="getPermission('attributes?.delete')"
              color="secondary"
              icon
              v-on="on"
              @click="openDeleteAttributeDialog(item)"
            >
              <v-icon v-text="icons.mdiDelete"></v-icon>
            </v-btn>
          </template>
          <span class="font-weight-bold" v-text="translations.delete[lang]"></span>
        </v-tooltip>
      </template>
    </b-data-table>

    <v-dialog v-model="attributesDialog" max-width="500">
      <AttributeForm v-if="attributesDialog === true" @close="attributesDialog = false" />
    </v-dialog>
    <v-dialog v-model="deleteAttributeDialog" max-width="500">
      <b-card
        type="delete"
        :title="translations.deleteAttribute[lang]"
        @cancel="deleteAttributeDialog = false"
        @submit="deletingAttribute()"
        :submit-text="translations.submit"
        :cancel-text="translations.cancel"
        :loading="loading"
      >
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <span>{{ translations.deleteAttributeConfirmation1[lang] }}</span>
            <v-col cols="12" md="12">
              <v-row v-if="deletingAttributeData.user_account_attribute_definition_id">
                <v-col cols="12" md="12"
                  ><span class="font-weight-bold pr-2">ID:</span>
                  {{ deletingAttributeData.user_account_attribute_definition_id }}</v-col
                >
                <v-col cols="12" md="12"
                  ><span class="font-weight-bold pr-2">{{ translations.name[lang] }}:</span>
                  {{ deletingAttributeData.name }}</v-col
                >
                <v-col cols="12" md="12"
                  ><span class="font-weight-bold pr-2">{{ translations.type[lang] }}:</span>
                  {{ deletingAttributeData.attribute_type }}</v-col
                >
                <v-col
                  v-if="deletingAttributeData.options && deletingAttributeData.options.length"
                  cols="12"
                  md="12"
                  class="d-flex flex-row"
                >
                  <span class="font-weight-bold pr-3 pt-2 mt-1"
                    >{{ translations.options[lang] }}:</span
                  >
                  <div v-if="deletingAttributeData.attribute_type == 'radio'">
                    <v-container class="px-0 pt-0 pb-0" fluid>
                      <v-radio-group row readonly class="mt-0">
                        <v-radio
                          readonly
                          v-for="n in deletingAttributeData.options"
                          color="secondary"
                          :key="n"
                          :label="`${n}`"
                          :value="n"
                        ></v-radio>
                      </v-radio-group>
                    </v-container>
                  </div>
                  <div v-else style="max-width: 400px">
                    <v-chip-group column class="table-chips">
                      <v-chip
                        v-for="(s, i) in deletingAttributeData.options"
                        :key="i"
                        class="font-weight-bold px-1 pr-2 pl-2"
                        style="overflow: auto; max-width: 380px"
                      >
                        {{ s }}
                      </v-chip>
                    </v-chip-group>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </b-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { cloneDeep, debounce } from 'lodash';
import translations from '@/utils/translations/loyaltyPanel/customers';
import AttributeForm from '@/components/loyaltyPanel/customers/AttributeForm.vue';
import { mdiPlus, mdiPencilOutline, mdiDelete, mdiCloseCircle } from '@mdi/js';

export default {
  name: 'AttributesTab',
  mixins: [translations],
  components: {
    AttributeForm,
  },
  data() {
    return {
      icons: {
        mdiPlus,
        mdiPencilOutline,
        mdiDelete,
        mdiCloseCircle,
      },
      page: 1,
      attributesDialog: false,
      deleteAttributeDialog: false,
      attributesData: { options: [] },
      deletingAttributeData: { options: [] },
      attributeOptions: [
        {
          name: '',
          typeName: 'Text',
          attribute_type: 'text',
          value: [],
        },
        {
          name: '',
          typeName: 'Select One',
          attribute_type: 'select',
          value: [
            {
              user_account_attribute_definition_value_id: null,
              value: null,
            },
          ],
        },
        {
          name: '',
          typeName: 'Select Multiple',
          attribute_type: 'multi_select',
          value: [
            {
              user_account_attribute_definition_value_id: null,
              value: null,
            },
          ],
        },
        {
          name: '',
          typeName: 'Radio Buttons',
          attribute_type: 'radio',
          value: [
            {
              user_account_attribute_definition_value_id: null,
              value: null,
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState([
      'loading',
      'superUser',
      'errorMessage',
      'serverItemsLength',
      'permissions',
      'storePermissions',
      'user',
    ]),
    ...mapState('loyaltyPanel/customers', ['attributes']),

    lang() {
      return this.$route.params.lang;
    },

    selectedAttributeOption() {
      return (
        this.attributeOptions.find((x) => x.attribute_type == this.attributesData.attribute_type) ||
        {}
      );
    },

    attributesQuery() {
      return this.searchAttributes ? `?q=${this.searchAttributes}` : '';
    },

    headersAttributes() {
      return [
        {
          text: 'ID',
          value: 'user_account_attribute_definition_id',
          width: 100,
        },
        {
          text: this.translations.name[this.lang],
          value: 'name',
          width: 200,
        },
        {
          text: this.translations.input[this.lang],
          value: 'attribute_type',
          width: 150,
        },
        {
          text: this.translations.type[this.lang],
          value: 'value_type',
          width: 150,
        },
        {
          text: this.translations.options[this.lang],
          value: 'user_account_attribute_definition_values',
          width: 200,
        },
        {
          text: this.translations.actions[this.lang],
          value: 'actions',
          width: 100,
        },
      ];
    },
  },
  methods: {
    ...mapMutations(['setResetValidation', 'setResetSuccess']),
    ...mapMutations('loyaltyPanel/customers', ['setAttributes', 'setAttribute']),
    ...mapActions('loyaltyPanel/customers', [
      'getAttributes',
      'createAttribute',
      'updateAttribute',
      'deleteAttribute',
    ]),
    ...mapMutations(['setDialog', 'setDeleteDialog', 'setResetSuccess', 'setResetValidation']),
    ...mapActions(['getPermission']),
    getPermission(path) {
      return (
        this.superUser ||
        (eval('this.permissions.' + path) && eval('this.storePermissions.' + path))
      );
    },
    openAttributesDialog(item) {
      this.setAttribute(item);

      this.attributesDialog = true;
    },

    openDeleteAttributeDialog(item) {
      this.deletingAttributeData = cloneDeep(item);
      this.deleteAttributeDialog = true;
    },

    async saveAttribute() {
      let id = this.attributesData.user_account_attribute_definition_id;
      let res;
      if (id) {
        res = await this.updateAttribute({ ...this.attributesData });
      } else {
        res = await this.createAttribute({ ...this.attributesData });
      }
      if (res && !res.error) {
        await this.getAttributes();
        this.attributesData = { options: [] };
        this.attributesDialog = false;
      }
    },
    removeAttributeOption(i) {
      this.selectedAttributeOption.value.splice(i, 1);
      this.attributesData.options.splice(i, 1);
    },
    addNewOption() {
      this.selectedAttributeOption.value.push({
        user_account_attribute_definition_value_id: null,
        value: null,
      });
    },
    async deletingAttribute() {
      let res = await this.deleteAttribute(
        this.deletingAttributeData.user_account_attribute_definition_id
      );
      if (res && !res.error) {
        this.deletingAttributeData = {};
        this.deleteAttributeDialog = false;
      }
    },

    handleSearchAttributes() {
      this.getAttributes(this.attributesQuery);
    },
  },
  created() {
    this.debouncedSearchAttributes = debounce(this.handleSearchAttributes, 500);
  },

  mounted() {
    this.getAttributes();
  },

  watch: {
    searchAttributes(val, oldVal) {
      if (val == null) {
        this.getAttributes(this.attributesQuery);
      } else {
        this.debouncedSearchAttributes();
      }
    },
    attributesDialog(val) {
      if (!val) {
        this.attributeOptions.forEach((e) => {
          if (e?.value?.length) {
            e.value = [
              {
                user_account_attribute_definition_value_id: null,
                value: null,
              },
            ];
          }
        });
      }
    },

    permissions: {
      handler(val, oldVal) {
        if (val && !this.getPermission('customers?.read')) {
          this.$router.replace(`/${this.lang}/${this.panelType}/forbidden-gateway`);
        }
      },
      deep: true,
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },
  },
};
</script>
